import styled from 'styled-components';

import { ACQ, COLORS } from '../../theme/tokens';
import { softCard, hoverWash } from '../../theme/mixins';
import { Text, StatGrid } from '../../components';

// --- "Your Influencers" header row ------------------------------------------
export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderTitle = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const Count = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  background: ${COLORS.surfaceMuted};
  color: ${COLORS.textMuted};
`;

// --- "campaign table" container — wraps the filter row + the influencer cards.
// Same surface as the Acquisition campaigns list (Figma "campaign table"): the
// #101012 outer card with a tight 4px gutter. ------
export const Panel = styled.div`
  background: ${ACQ.cardOuter};
  border-radius: 16px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// --- Filter row ("Filter:" + deal-type chips) -------------------------------
export const Filters = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
`;

export const FilterLbl = styled(Text)`
  flex-shrink: 0;
  font-size: 12px;
  color: ${ACQ.placeholder};
`;

export const FilterChips = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Pill = styled.button<{ $on: boolean }>`
  height: 48px;
  min-width: 48px;
  padding: 0 15px;
  border-radius: 16px;
  flex-shrink: 0;
  font-size: 12px;
  cursor: pointer;
  background: ${(p) => (p.$on ? ACQ.orangeTint : ACQ.pillBg)};
  border: 1px solid ${(p) => (p.$on ? ACQ.orangeBorder : ACQ.pillBorder)};
  color: ${(p) => (p.$on ? ACQ.orange : ACQ.t400)};
`;

// --- Influencer cards -------------------------------------------------------
// Sits inside Panel; the 6px side/bottom inset gives the cards the same gutter
// the filter row's own 6px padding does (cards land ~10px off the container edge).
export const InfList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 6px 6px;
`;

export const InfCard = styled.div`
  ${softCard}
  ${hoverWash}
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  outline: none;
`;

export const InfTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const InfName = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const NoteRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

// --- Stats grid -------------------------------------------------------------
// Each stat sits in its own recessed tile (Figma "campaign table": a transparent
// dark box, 8px radius, 10px pad, packed in a tight 2px-gutter grid) so the row
// reads as a segmented panel rather than free-floating figures.
export const BoxedStatGrid = styled(StatGrid)`
  gap: 2px;
  & > * {
    background: ${COLORS.metricTileBg};
    border-radius: 8px;
    padding: 10px;
  }
`;
